export default {"src":"/_next/static/media/plus_icon.18fc4ac6.svg","height":67,"width":67,"blurWidth":0,"blurHeight":0};